import { memo } from 'react'

import { ITableContainer, ITableHeaders, ITableBody, ITableRow } from './table.type'
import css from './table.module.scss'
import Loader from '../loader/loader'


/** Таблица - Контейнер */
export const TableContainer = memo(({isLoading, loadingTitle, children, className}: ITableContainer)=> {
    return <>
        <div className={`${css.table_container} ${className}`}>
            {isLoading && <Loader isOpen={isLoading} backdrop color='#f34e2e' title={loadingTitle} />}
            {children}
        </div>
    </>
})

/** Таблица - Заголовок */
export const TableHeaders = memo(({children, classGridTemplateColumns, marginLeft, marginRight}: ITableHeaders)=> {
    return (
        <div className={`${css.table_container__headers} ${classGridTemplateColumns}`} style={{ marginLeft: marginLeft, marginRight: marginRight }}>
            {children}
        </div>
    )
})

/** Таблица - Тело под строки */
export const TableBody = memo(({children, overflowY = 'scroll'}: ITableBody)=> {
    const componentStyle: React.CSSProperties = {
        overflow: 'hidden',
        overflowY: overflowY,
        paddingRight: overflowY === 'hidden' ? '0' : '4px'
    }

    return (
        <div className={css.table_container__body} style={componentStyle}>
            {children}
        </div>
    )
})

/** Таблица - Строка с данными */
export const TableRow = memo(({indexNumber, indexNumberWidth, children, classGridTemplateColumns, backgroundColor, backgroundColorInset, paddingInset, onClick}: ITableRow)=> {
    return (
        <div className={css.table_container__row} style={{background: backgroundColor}} onClick={onClick}>
            <span style={{ textAlign: 'center', width:  indexNumberWidth}}>{indexNumber}</span>

            <div className={`${css.table_container__row_inset} ${classGridTemplateColumns}`} style={{background: backgroundColorInset, padding: paddingInset}}>
                {children}
            </div>
        </div>
    )
})